<script setup lang="ts">
const { pricingData } = useLandingData()
</script>

<template>
  <section id="harga" class="mt-[60px] sm:mt-[94px] container mx-auto px-4">
    <AnimateOnScroll animation="fade-down">
      <div>
        <h2 class="text-[32px] sm:text-[42px] font-medium text-neutral-700 text-center">
          Buat Invoice di Rintisan Billing
          <br class="hidden md:block">
          secara GRATIS dengan MDR Rate
          <br class="hidden md:block">
          <span class="gradient-text">Terendah Se-Indonesia</span>
        </h2>
        <p class="mt-5 sm:mt-4 text-lg font-normal text-center text-neutral-700">
          Nikmati penggunaan Invoice dengan rate terendah di Indonesia secara GRATIS
        </p>
      </div>
    </AnimateOnScroll>

    <AnimateOnScroll animation="zoom-in">
      <div class="w-full md:max-w-3xl relative mt-[80px] sm:mt-[118px] p-0 sm:p-4 mx-auto">
        <div class="absolute -top-[30px] bg-gradient-rintisan text-center text-white text-[11px] sm:text-base py-[7px] sm:py-3 w-[110px] sm:w-[230px] rounded-t-lg right-2 sm:right-5">
          Best Value
        </div>

        <div class="border rounded-lg border-neutral-200 bg-gradient-putih relative overflow-hidden shadow-sm">
          <div class="shadow-inners" />
          <table class="w-full text-sm text-left rounded-lg">
            <thead>
              <tr>
                <th class="py-3 md:py-5 px-2.5 md:px-[45px] whitespace-nowrap border border-neutral-200 font-semibold bg-[#FECBD433]">
                  <span class="text-[9px] md:text-base gradient-text">
                    Metode Pembayaran
                  </span>
                </th>
                <th class="py-3 md:py-5 px-2.5 md:px-[45px] whitespace-nowrap border text-center border-neutral-200 font-semibold bg-[#FECBD433]">
                  <span class="text-[9px] md:text-base gradient-text">
                    Platform Lain
                  </span>
                </th>
                <th class="py-3 md:py-5 px-2.5 md:px-[45px] whitespace-nowrap border text-center border-neutral-200 font-semibold bg-[#FECBD433]">
                  <span class="text-[9px] md:text-base gradient-text">
                    Rintisan Billing
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-neutral-200">
              <tr v-for="(item, index) in pricingData" :key="index">
                <td class="flex items-center px-2.5 md:px-[45px] py-3 md:py-5 space-x-2 border-r border-neutral-200">
                  <div>
                    <img
                      class="h-5 w-[50px] md:h-6 md:w-auto object-contain"
                      :src="item.icon"
                      :alt="item.type || 'Payment Method'"
                      width="50"
                      height="20"
                      loading="lazy"
                    >
                    <div
                      :class="{
                        'flex gap-2 items-center mt-1': item.img1 || item.img2,
                      }"
                    >
                      <p
                        v-if="item.type"
                        class="text-[8px] md:text-sm md:mt-1 text-neutral-500"
                      >
                        {{ item.type }}
                      </p>
                      <img
                        v-if="item.img1"
                        :class="item.classimg1"
                        class="h-4 w-[37px] object-contain"
                        :src="item.img1"
                        alt="Additional Payment Method"
                        width="37"
                        height="16"
                        loading="lazy"
                      >
                      <img
                        v-if="item.img2"
                        class="h-4 w-[37px] object-contain"
                        :src="item.img2"
                        alt="Additional Payment Method"
                        width="37"
                        height="16"
                        loading="lazy"
                      >
                    </div>
                  </div>
                </td>

                <td class="px-2.5 md:px-6 py-3 md:py-4 text-[11px] md:text-base text-center border-r text-neutral-700 border-neutral-200">
                  {{ item.otherPlatform }}
                </td>

                <td class="text-center px-1 md:px-4">
                  <div class="flex items-center justify-center gap-1 md:gap-2">
                    <span class="text-[11px] md:text-sm line-through text-destructive">{{ item.defaultBilling }}</span>
                    <span class="text-[11px] md:text-sm font-normal text-neutral-700">{{ item.rintisanBilling }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </AnimateOnScroll>
  </section>
</template>
